<template>
  <div>
    <ValidationObserver ref="validator">
      <form @submit.prevent="submit">
        <div v-for="(field, index) in formFields" :key="index">
        <dynamic-form-item :field="field" :formData="formData" @change="onValueUpdate" />
        </div>
        <br />
        <md-button v-if="!hideSubmit" class="md-success" type="submit">{{submitButtonText || 'Absenden'}}</md-button>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import DynamicFormItem from './DynamicFormItem';

export default {
  props: ["formFields", "hideSubmit", "initialFormData", "submitButtonText"],
  components: {
    DynamicFormItem
  },
  data() {
    return {
      editedFormData: {},
      defaultFormData: {}
    };
  },
  watch: {
    initialFormData: 'resetDefaults',
    formFields: 'resetDefaults'
  },
  mounted() {
    this.resetDefaults();
  },
  computed: {
    formData() {
      return { ...this.defaultFormData, ...this.editedFormData };
    },
  },
  methods: {
    onValueUpdate(fieldName, newValue) {
      const oldValue = this.formData[fieldName];
      this.setValue(fieldName, newValue);
      if (oldValue !== newValue) {
        this.$emit('update', this.formData, fieldName, newValue, oldValue);
      }
    },
    setValue(fieldName, value) {
      if (this.defaultFormData[fieldName] === value) {
        if (this.editedFormData.hasOwnProperty(fieldName)) {
          this.editedFormData = { ...this.editedFormData };
          delete this.editedFormData[fieldName];
        }
      } else if (this.editedFormData[fieldName] !== value) {
        this.editedFormData = { ...this.editedFormData, [fieldName]: value };
      }
    },
    isDirty(fieldName) {
      return this.editedFormData.hasOwnProperty(fieldName);
    },
    validate() {
      return this.$refs.validator.validate();
    },
    isValid() {
      return this.$refs.validator.validate({ silent: true });
    },
    resetValidation() {
      this.$refs.validator.reset();
    },
    resetDefaults() {
      this.resetValidation();
      const defaultValues = this.getDefaultValues(this.formFields);
      this.defaultFormData = { ...defaultValues, ...this.initialFormData };
    },
    reset() {
      this.resetValidation();
      this.editedFormData = {};
    },
    getDefaultValues(formFields) {
      let defaultValues = {};
      formFields.forEach(f => {
        if (f.value != null && f.name) {
          defaultValues[f.name] = f.value;
        } else if (f.children) {
          defaultValues = { ...defaultValues, ...(this.getDefaultValues(f.children))}
        }
      });
      return defaultValues;
    },
    formatDynamicDate(date) {
      var d = new Date(date),
          month = "" + (d.getMonth() + 1),
          day = "" + d.getDate(),
          year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [day, month, year].join(".");
    },
    getTitleLabel(field) {
      if(field.required) {
        return field.title + "*";
      } else {
        return field.title;
      }
    },
    getRequiredValidation(field) {
      if(field.name == "email") {
        return "email";
      } else {
        if(field.required != null && field.required) {
          return "required";
        }
      }
      return "";
    },
    formFieldHasPropertyWithValue(name) {
      if(this.formData.hasOwnProperty(name) && this.formData[name] != "") {
        return true;
      }
      return false;
    },
    checkMandatoryFields(joinForm) {
      if (joinForm == null) {
        return true;
      }
      for (var i = 0; i < joinForm.length; i++) {
        if (joinForm[i].required && !this.formFieldHasPropertyWithValue(joinForm[i].name)) {
          // console.log(i, joinForm, this.formData)
          return false;
        }
      }
      return true;
    },
    submit() {
      return this.validate().then(isValid => {
        if (isValid) {
          if (this.checkMandatoryFields(this.joinForm)) {
            this.$emit('submit', this.formData);
            return this.formData;
          } else {
            this.$notify({
              timeout: 5000,
              message:
                "Die Pflichtfelder mit * müssen ausgefüllt sein damit du dich anmelden kannst!",
              icon: "add_alert",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "danger"
            });
          }
        }
      });
    },
  },
};
</script>

<style lang="css" scoped>
  .list-move {
    transition: transform .4s;
  }
  .list-enter-active, .list-leave-active {
    transition: all .4s;
    transform-origin: top left;
  }
  .list-enter, .list-leave-to {
    opacity: 0;
    transform: scaleY(0);
  }
</style>
